<template>
  <ShowControl  @revert="revertClick"  :title="title" ref="showControl" v-loading="loadings">
      <div class="main" v-if="showMain">
        <div class="frour">
          <div>
              <FrameControl>
                <EnrollStatistics></EnrollStatistics>
              </FrameControl>
          </div>
          <div style="display: flex; justify-content: center;">
            <FrameControl>
              <div class="icondiv">
                <div>
                  <el-button type="text"
                            @click="ExhibitionPlanning">
                    <div>
                      <div>
                        <i class="icon iconfont icon-huodongcehua"
                          style="font-size:calc(100vw * 80 / 1920)"></i>
                      </div>
                      <div>会展策划</div>
                    </div>
                  </el-button>
                </div>
                <div>
                  <el-button type="text"
                            @click="BudgetCustomized()">
                    <div>
                      <div>
                        <i class="icon iconfont icon-yusuanguanli"
                          style="font-size:calc(100vw * 80 / 1920)"></i>
                      </div>
                      <div>预算制定</div>
                    </div>
                  </el-button>
                </div>
                <div>
                  <el-button type="text"
                            @click="PriceCustomized()">
                    <div>
                      <div>
                        <i class="icon iconfont icon-jiageyuce"
                          style="font-size:calc(100vw * 90 / 1920)"></i>
                      </div>
                      <div>价格制定</div>
                    </div>
                  </el-button>
                </div>
                <div>
                  <el-button type="text"
                            @click="AIGenerate()">
                    <div>
                      <div>
                        <i class="icon iconfont icon-AIzhushou"
                          style="font-size:calc(100vw * 80 / 1920)"></i>
                      </div>
                      <div>AI会展策划书生成</div>
                    </div>
                  </el-button>
                </div>
                <div>
                  <el-button type="text"
                            @click="ReportExport">
                    <div>
                      <div>
                        <i class="icon iconfont icon-daochu"
                          style="font-size:calc(100vw * 80 / 1920)"></i>
                      </div>
                      <div style="margin-top: 10px;">实验报告管理</div>
                    </div>
                  </el-button>
                </div>
              </div>
          </FrameControl>
          </div>
          <div>
            <FrameControl>
                <NumberStatistics></NumberStatistics>
            </FrameControl>
          </div>
    
            <FrameControl>
              <div style="display: flex;  flex-direction:column; justify-content: center;width: 100%;">
                <div style="display: flex;flex-wrap: wrap;justify-content: center;">
                  <el-steps :active="active"
                            finish-status="success"
                            style="width: 90%;">
                    <el-step v-for="item in TFlowList"
                            :key="item.id"
                            :title="item.name" />
                  </el-steps>
                </div>
                <div style="display: flex;flex-wrap: wrap;
                    justify-content: space-around;">
                  <el-button style="margin-top: 12px"
                            type="primary"
                            @click="next"
                            :disabled="active==5">下一步</el-button>
                  <el-button style="margin-top: 12px"
                            type="primary"
                            @click="reload">重新开始</el-button>
                  <el-button style="margin-top: 12px"
                            type="primary"
                            @click="nextround">下一个回合</el-button>
                </div>
              </div>
            </FrameControl>
        </div>
      </div>
    <AIGenerateCard v-if="AIGenerateCardView" :AICardtransfer="AItransfer"></AIGenerateCard>
  </ShowControl>
</template>
<script>
import EnrollStatistics from "../ProjectManagement/EnrollStatistics.vue"
import NumberStatistics from "../ProjectManagement/NumberStatistics.vue"
import { mapState } from "vuex";
import { ElLoading } from "element-plus";
import ShowControl from "../UserControl/ShowControl.vue"
import FrameControl from "../UserControl/FrameControl.vue"
import AIGenerateCard from "../Card/AIGenerate/AIGenerateCard.vue"
export default {
  components: {
    EnrollStatistics,
    NumberStatistics,
    ShowControl,
    FrameControl,
    AIGenerateCard
  },
  computed: {
    ...mapState({
      Round: (state) => state.user.round,
      Commit: (state) => state.user.commit,
      TaskBar: (state) => state.user.taskBar,
    }),
  },
  beforeRouteUpdate (to, from, next) {
    next(vm => {
      console.log(vm);
    })
    if (to.query.str != undefined) {
      this.cardview(to.query.str);
    }
  },
  data () {
    return {
      AIGenerateCardView:false,
      TFlowList: [],
      IFlowList: {},
      active: 0,
      groupID: localStorage.getItem("groupID"),
      showMain: true,
      title: '项目管理',
      reportID:null,
      AItransfer:{
      },
      AIID:0,
      AI:{},
      typedText: '',
      loadings:false
    };
  },
  watch: {
    Commit (val) {
      if (!isNaN(val))
        this.GetIFlowAll();
    },
    Round (val) {
      if (!isNaN(val)) {
        this.GetIFlowAll();
      }

    },
  },
  created () {
  },
  mounted () {
    if (this.$route.query.str != undefined) {
      this.cardview(this.$route.query.str);
    }
    this.GetAllTFlow();
  },
  methods: {
    cardview (str) {
      this.$refs.showControl.receiveValue(true);
      this.showMain=false
      this.handleClose()
      if (str == 'ExhibitionPlanningCard') {
        this.$router.push("/ExhibitionPlanningNewCard")
      } else if (str == 'BudgetCustomizedCard') {
        this.$router.push("/BudgetCustomizedCard")
      } else if (str == 'PriceCustomizedCard') {
        this.$router.push("/PriceCustomizedCard")
      } else if (str == 'ReportExportCard') {
        this.$router.push("/ReportExportCard")
      }
    },
    getNowTime () {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      month = month + 1;
      month = month.toString().padStart(2, "0");
      date = date.toString().padStart(2, "0");
      var defaultDate = `${year}-${month}-${date}`;
      this.$set(this.form, "startTime", defaultDate);
    },
    getHotelInfo () {
      this.$http
        .get(
          "User/GetMoney?groupId=" +
          this.Global.groupid +
          "&round=" +
          this.round
        )
        .then((res) => {
          if (res.success) {
            this.$store.commit("setMoney", res.dynamicObj);
          } else {
            return this.$message.warning(res.message);
          }
        });
    },
    isloading () {
      let that = this;
      const loading = ElLoading.service({
        lock: true,
        text: "颜值高的组都已提交了(｀・ω・')",
        // background: "rgba(0, 0, 0, 0.7)",
      });
      const timer = setInterval(function () {
        that.$http
          .get(`Run/IsComit`)
          .then((childre) => {
            if (childre.success) {
              if (childre.dynamicObj.isRun) {
                clearInterval(timer);
                that.$store.commit("coomitmd", 0);
                that.$store.commit("changedepcomit", 0);
                let nextround = childre.dynamicObj.nextRound;
                that.$store.commit("changeround", nextround);
                that.getHotelInfo();
                loading.close();
              }
            } else {
              return that.$message.warning(childre.message);
            }
          });
      }, 5000);
    },
    GetIFlowAll () {
      this.$http
        .get(
          "Flow/GetFlowList?round=" + this.Round
        )
        .then((res) => {
          if (res.success) {
            this.IFlowList = res.dynamicObj;
            if (this.IFlowList.length > 0) {
              this.active = this.IFlowList[0].flowID;
              localStorage.setItem('flowID', this.active)
            }

          } else {
            return this.$message.error(res.message);
          }
        });
    },
    next () {
      let that = this;
      this.$http
        .get("Run/RunAlg?groupid=" + this.groupID + "&round=" + this.Round)
        .then((res) => {
          if (res.dynamicObj) {
            that.$store.commit("changedepcomit", 1);
          } else {
            this.$message.error(res.message);
            return false;
          }
        });

    },
    reload () {
      let that = this;
      that.$confirm("是否确认重新开始？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.$store.commit("changedepcomit", 1);
          this.$http
            .get("Run/Reload?groupid=" + this.groupID + "&round=" + this.Round)
            .then((res) => {
              if (res.success) {
                that.$store.commit("GetTaskBar", !this.TaskBar);
                that.$store.commit("operatedepcomit", 0);
                that.$store.commit("checkSummarizecomit", 0);
                console.log(res.dynamicObj)
              } else {
                this.$message.error(res.message);
                return false;
              }
            });
        })
        .catch(() => { });
    },
    nextround () {
      let that = this;
      this.$http
        .get("Run/NextRound?round=" + this.Round)
        .then((res) => {
          if (res.dynamicObj) {
            that.$store.commit("changedepcomit", 1);
          } else {
            this.$message.error(res.message);
            return false;
          }
        });

    },
    handleClose () {
      this.AIGenerateCardView =false
    },
    BudgetCustomized () {
      this.$router.push("/BudgetCustomizedCard")
    },
    ExhibitionPlanning () {
      this.$router.push("/ExhibitionPlanningNewCard")
    },
    PriceCustomized () {
      this.$router.push("/PriceCustomizedCard")
    },
    ReportExport () {
      this.$router.push("/ReportExportCard")
    },
    AIGenerate () {
      this.loadings=true
      this.GetAI()
    },
    GetAllTFlow () {
      this.$http
        .get("TFlow/GetModel")
        .then((res) => {
          if (res.success) {
            this.TFlowList = res.dynamicObj;
            this.GetIFlowAll();
          } else {
            return this.$message.error(res.message);
          }
        });
    },
    revertClick(){
      if(this.ReportExportDetailCardView){
        this.ReportExportDetailCardView= false
        this.ReportExport()
      }else{
        this.showMain=true
        this.title = '项目管理'
        this.handleClose();
      }
    },
    ReportID(id){
      this.ReportExportCardView= false
      this.reportID = id
      this.ReportExportDetailCardView= true
    },
    GetAI(){
      this.AI={}
      this.$http.get(`StudentData/GetAI?Round=${this.Round}&Type=${this.Global.AiEnum.会展策划}&ParentID=0`).then((res)=>{
        if (res.success) {
          this.AI = res.dynamicObj
          if (this.AI===null) {
            this.GetPlanningData()
          } else {
            this.AIID = res.dynamicObj.id
            this.typedText= res.dynamicObj.answer
            this.GetPlanningData()
          }
        } else {
          this.loadings=false
          return this.$message.warning(res.message)
        }
      })
    
    },
    GetPlanningData () {
      this.$http
        .get(
          "StudentData/GetPlanningData?round=" + this.Round
        )
        .then((res) => {
          if (res.success) {
            let data = res.dynamicObj;
            var starData = this.filter.formatDate( data.starData , "yyyy年M月d日")
            var endData =this.filter.formatDate( data.endData , "yyyy年M月d日")
            var copywriting = `会展名称：海丝博览会；会展主题：${data.themes}；目标市场：${data.targetMarket}；会展场馆：${data.exhibitionVenue}；大展位数量${data.largeBoothArea}个；中展位数量${data.mediumBoothArea}个；小展位数量${data.smallBoothArea}个；开始日期：${starData}；结束日期：${endData}；
             会展预算包括会场费用${data.venueCost}元、设计费用${data.designCost}元、招商费用${data.attractInvestment}元、媒体费用${data.mediaCost}元、宣传推广费用${data.promotionExpenses}元、专家费用（含差旅费）${data.expertFees}元、其它费用${data.otherCost}元；
             会展收入主要来源于门票收入（${data.admissionFee}元/张）、大展位费用（${data.largeBoothbudget}元/个）、中展位费用（${data.mediumBoothbudget}元/个）、小展位费用（${data.smallBoothbudget}元/个）、主题演讲费用（${data.keynoteCost}元/人）`
            this.generate(copywriting)
          } else {
            this.loadings=false
            return this.$message.error(res.message);
          }
        });
    },
    generate(copywriting){
      const xhr = new XMLHttpRequest();
      xhr.open('GET', this.Global.chaturl + `api/Chat/ChatTeampleMsg?teampid=${this.Global.chatTemplateID.会展策划}`);
      xhr.setRequestHeader('Content-Type', 'text/event-stream');
      xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
            if(xhr.responseText=="")
            {
              this.$message.warning("AI生成失败，请联系管理员！");
              return;
            }
            // 避免接受过程中缺少字符
            const responseData=  xhr.responseText.replace(/\s+/g, '').trim();
            this.template=decodeURIComponent(JSON.parse(responseData).data).replace("{}",copywriting);
            this.AItransfer ={
              problem:this.template,
              type:this.Global.AiEnum.会展策划,
              answer:this.typedText,
              parentID: 0,
              id:this.AI===null?0:this.AIID
            }
            this.$refs.showControl.receiveValue(true);
            this.title= "AI会展策划书生成"
            this.showMain = false
            this.loadings = false
            this.AIGenerateCardView =true
          }
        }
      }
      xhr.send();
    },
  },
};
</script>

<style lang="less" scoped>
.icondiv {
  display: flex;
  flex-flow: wrap;
  justify-content: center;
  height: 100%;
  align-content: center;
  align-items: center;
  overflow: auto;
  > div {
    display: flex;
    width: 32%;
    text-align: center;
    height: 45%;
    justify-content: center;
  }
}
</style>
<style scoped>
.main {
  display: flex;
  flex-flow: column;
  height: 100%;
  width: 100%;
}
.frour {
  /* background-image: url("../../images/bg.png"); */
  /* background-color: #e8e8e8; */
  display: flex;
  /* flex: auto; */
  justify-content: center;
  align-content: center;
  align-items: center;
  flex-wrap: wrap;
  height: 100%;
  border-radius: 0px 0px 15px 15px;
}
.frour > div {
  display: flex;
  flex-wrap: wrap;
  margin: 10px;
  height: calc((100% - 40px) / 2);
  width: calc((100% - 60px) / 2);
}
</style>